
  // Функция для группировки данных по индексу
const groupSubtopicsByIndex = (data) => {
    return data.map(topic => {
        const groupedSubtopics = {};
        
        // Группируем субтопики текущего топика по индексу
        topic.subtopics.forEach(sub => {
            const subIndex = sub.index ? sub.index : 'NoIndex';

            if (!groupedSubtopics[subIndex]) {
                groupedSubtopics[subIndex] = {
                index: subIndex,
                names: [],
                semanticWords: []
                };
            }
            
            groupedSubtopics[subIndex].names.push(sub.name);
            
            // Добавляем семантические слова
            sub.semantic_words.forEach(word => {
                groupedSubtopics[subIndex].semanticWords.push({
                name: word.name,
                weight: word.weight
                });
            });
        });
        
        // Преобразуем объект группировки в массив
        return {
            ...topic,
            groupedSubtopics: Object.values(groupedSubtopics)
        };
    });
}


export default groupSubtopicsByIndex;